import { Component, OnInit, ViewChild } from '@angular/core';
import { EpbtFaLabelsService } from '../../services/epbt-fa-labels.service';
import { EpButtonStyle, EpEventService } from '@epicor/kinetic';
import { FieldAgentClient, LabelsRequest } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { CustomEvents, PageNames, LocalStorageSaveTypes } from 'ep-bt-controls';
import { EpbtFaLabelSummaryTemplatesGridComponent } from '../epbt-fa-label-summary-templates-grid/epbt-fa-label-summary-templates-grid.component';
import { EpbtFaLabelSelectedProductsGridComponent } from '../epbt-fa-label-selected-products-grid/epbt-fa-label-selected-products-grid.component';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaLabelSummaryProductsGridComponent } from '../epbt-fa-label-summary-products-grid/epbt-fa-label-summary-products-grid.component';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-label-summary',
  templateUrl: './epbt-fa-label-summary.component.html',
  styleUrls: ['./epbt-fa-label-summary.component.scss']
})
export class EpbtFaLabelSummaryComponent implements OnInit {

  EpButtonStyle = EpButtonStyle;
  @ViewChild(EpbtFaLabelSummaryTemplatesGridComponent, {static: false}) epbtFaLabelSummaryTemplatesGridComponent: EpbtFaLabelSummaryTemplatesGridComponent;
  @ViewChild(EpbtFaLabelSelectedProductsGridComponent, {static: false}) epbtFaLabelSelectedProductsGridComponent: EpbtFaLabelSelectedProductsGridComponent;
  @ViewChild(EpbtFaLabelSummaryProductsGridComponent, {static: false}) summaryProductsGridComponent: EpbtFaLabelSummaryProductsGridComponent;

  constructor(public faLabelsService: EpbtFaLabelsService, private client: FieldAgentClient,
    public epEvent: EpEventService, private route: Router, private productService: EpbtFaProductService) { }

  ngOnInit() {
  }

  submitClicked() {
    // Remove all 0-qty requests
    const result = this.faLabelsService.labelsRequest.templates.filter(qty => qty.requestedQuantity > 0);
    this.faLabelsService.labelsRequest.templates = result;
    if (this.faLabelsService.labelsRequest.templates.length > 0) {
      console.log('LabelsRequest Input:' + JSON.stringify(this.faLabelsService.labelsRequest));
      this.client.printLabels(this.faLabelsService.webTrackUser.bisTrackUserId, this.faLabelsService.labelsRequest).subscribe(res => {
        // Any errors?
        const errors = res.filter(x => x.errorMessage != null);
        if (errors.length > 0) {
          const errorsCount = res.filter(x => x.errorMessage == null);
          this.faLabelsService.successMessage = res.length + ' of ' + res.length + ' requests were successfully submitted.' + ' The errors were:' + errorsCount + res.length;
        } else {
          this.faLabelsService.successMessage = res.length + ' of ' + res.length + ' requests were successfully submitted.';
          this.faLabelsService.labelsRequest.templates = []; // clear data
          // this.faLabelsService.clearSubmitClikLabelsData();
        }
      });
    }
  }

  okClicked() {
    this.navigateOnSummaary();
  }

  doneClicked() {
    this.navigateOnSummaary();
  }

  navigateOnSummaary() {
    if (this.faLabelsService.fromDashboard) {
      this.route.navigate(['/home']);
    } else {
      if (this.productService.selectedProductItem) {
        localStorage.setItem(LocalStorageSaveTypes.ProIndex, '0');
        // this.productService.fromPage = PageNames.ProductSearch;
        this.route.navigate(['/home/product/details/', this.productService.selectedProductItem.productId]);
      } else {
        this.route.navigate(['/home']);
      }
    }
    this.faLabelsService.clearLabelsData();
  }

  onBranchClick() {
    this.epEvent.broadcast(CustomEvents.LabelTemplatesSummaryClick, 0);
  }

  updateLabelSummaryTemplateGridData() {
    this.epbtFaLabelSummaryTemplatesGridComponent.updateLabelSummaryTemplateGridData();
  }

  updateLabelSummaryProductsGridData() {
    this.summaryProductsGridComponent.updateLabelsSummaryProductsGridData();
  }
}
